import React, { memo } from 'react'
import { ISelectOption, Select } from 'components/forms/Selects'
import { ChangeRateData } from 'apps/marketplace/utils/helpers/useCarrier'
import { Checkbox } from 'components/forms'
import { EQUIPMENT_FOR_LANES } from 'constants/equipment'

interface IEquipmentProps {
  equipmentId: number
  isOnlyBeer: boolean | null
  isOnlyDropTrailer: boolean | null
  onChange: (arg: Partial<ChangeRateData>) => void
  disabled: boolean
}

export const Equipment = memo<IEquipmentProps>(
  ({ disabled, equipmentId, isOnlyBeer, isOnlyDropTrailer, onChange }) => {
    const equipmentHandler = ({ value }: ISelectOption) => {
      onChange({ equipmentId: value })
    }
    const checkboxHandler = ({ target: { checked, id } }: React.ChangeEvent<HTMLInputElement>) => {
      onChange({ [id]: checked })
    }
    return (
      <>
        <div className='col-md-3 col-xs-4'>
          <Select
            id='equipment'
            label='Equipment Type'
            required
            options={EQUIPMENT_FOR_LANES}
            value={EQUIPMENT_FOR_LANES.find(entry => entry.id === parseInt(`${equipmentId}`, 10))}
            onChange={equipmentHandler}
            dataTest='add-equipment'
            disabled={disabled}
          />
        </div>
        <div className='col-xs-4 flex pt4'>
          <span>
            <Checkbox
              id='isOnlyBeer'
              dataTest='is-only-beer'
              label='Beer Only'
              checked={Boolean(isOnlyBeer)}
              onChange={checkboxHandler}
            />
          </span>
          <span className='pl4'>
            <Checkbox
              id='isOnlyDropTrailer'
              dataTest='is-only-drop-trailer'
              label='Drop Trailer'
              checked={Boolean(isOnlyDropTrailer)}
              onChange={checkboxHandler}
              disabled={disabled}
            />
          </span>
        </div>
      </>
    )
  }
)
